import Popup from "../../../components/popups/Popup";
import { COLOR_APP_TEXT } from "../../../components/theme";
import InformationIcon from "../../../components/icons/InformationIcon";
import { getWeddingRestrictionContent } from "./questionnaire";

interface WeddingRestrictionPopupProps {
  stateAbbreviation: string;
  onConfirm: () => void;
}

const WeddingRestrictionPopup = ({
  stateAbbreviation,
  onConfirm,
}: WeddingRestrictionPopupProps) => {
  const { title, description } =
    getWeddingRestrictionContent(stateAbbreviation);
  return (
    <Popup
      title={title}
      icon={<InformationIcon color={COLOR_APP_TEXT} />}
      description={description}
      buttons={{
        confirmText: "Reschedule my marriage date",
        cancelText: "Join postnup waitlist",
        onConfirm,
        onCancel: () => {
          window.open(
            "https://airtable.com/app2ZKE3j9r7Q7URH/shrX5lImXa4zqAdDD",
            "_blank",
          );
        },
      }}
    />
  );
};

export default WeddingRestrictionPopup;
